import { render, staticRenderFns } from "./StockTakingResult.vue?vue&type=template&id=2477dc32&scoped=true"
import script from "./StockTakingResult.vue?vue&type=script&lang=js"
export * from "./StockTakingResult.vue?vue&type=script&lang=js"
import style0 from "./StockTakingResult.vue?vue&type=style&index=0&id=2477dc32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2477dc32",
  null
  
)

export default component.exports